var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _g2, _g3, _g4, _g5, _rect, _rect2, _g6, _path26, _path27, _g7, _path28, _path29, _g8, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankingCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 138,
    viewBox: "0 0 157 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.381 75.4675C141.381 109.451 113.831 137 79.8482 137C45.8652 137 18.3164 109.451 18.3164 75.4675C18.3164 41.4844 45.8652 13.9351 79.8482 13.9351C113.831 13.9351 141.381 41.4844 141.381 75.4675Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.827259,
    strokeDasharray: "4.15 4.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.542 75.4677C125.542 100.704 105.084 121.162 79.848 121.162C54.6114 121.162 34.1543 100.704 34.1543 75.4677C34.1543 50.2317 54.6114 29.7734 79.848 29.7734C105.084 29.7734 125.542 50.2317 125.542 75.4677Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.827259,
    strokeDasharray: "4.17 4.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69126 83.7523L5.54883 83.7173",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87206 81.5859L5.05273 82.3513",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73692 80.5972L3.71973 81.7141",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53516 81.3638L2.33077 82.1784",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.558594 83.438L1.70043 83.473",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37793 85.6042L2.19785 84.8389",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51367 86.5935L3.53086 85.4766",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71456 85.8263L4.91895 85.0117",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.678 67.8281L155.176 68.3718",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.32 68.3003L153.699 68.6495",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.938 70.7102L153.441 70.1665",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.295 70.2374L154.917 69.8882",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.685 3.93251L108.471 3.8999",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.543 1L106.524 2.03809",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.162 3.64062L104.377 3.67264",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.306 6.57325L106.324 5.53516",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.73 116.018C18.8561 116.279 17.4007 117.563 16.9027 119.086C16.8191 117.671 15.9209 115.893 14.9326 115.637C16.1385 115.211 17.4445 113.644 17.792 112.324C17.7291 113.707 18.9854 115.717 19.73 116.018Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1968 9.49305C39.5227 9.61222 38.3281 10.4422 37.8254 11.5331C37.8852 10.4724 37.37 9.07035 36.6562 8.79408C37.5912 8.58065 38.6998 7.52655 39.0727 6.57324C38.9061 7.59888 39.668 9.20433 40.1968 9.49305Z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.54 17.1949C128.639 17.1753 127.926 16.4301 127.946 15.5301C127.965 14.6302 128.711 13.9164 129.61 13.9359C130.51 13.9555 131.224 14.7007 131.205 15.6007C131.184 16.5006 130.44 17.2144 129.54 17.1949Z",
    fill: "#D1D9E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.543 123.999C128.76 123.983 128.139 123.334 128.156 122.55C128.172 121.767 128.821 121.145 129.605 121.162C130.389 121.179 131.01 121.828 130.993 122.611C130.976 123.395 130.327 124.017 129.543 123.999Z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7177 38.8262C11.2327 38.8155 10.8479 38.4141 10.8586 37.9286C10.8687 37.4436 11.2706 37.0595 11.7556 37.0695C12.2406 37.0802 12.6253 37.4816 12.6152 37.9665C12.6046 38.4521 12.2026 38.8368 11.7177 38.8262Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.226 130.485C109.029 130.485 131.567 107.906 131.567 80.0536C131.567 52.2013 109.029 29.6226 81.226 29.6226C53.4233 29.6226 30.8848 52.2013 30.8848 80.0536C30.8848 107.906 53.4233 130.485 81.226 130.485Z",
    stroke: "#A19FC4",
    strokeOpacity: 0.08,
    strokeWidth: 0.573529
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1431 120.808C103.385 120.808 121.416 102.519 121.416 79.9585C121.416 57.3982 103.385 39.1094 81.1431 39.1094C58.9009 39.1094 40.8701 57.3982 40.8701 79.9585C40.8701 102.519 58.9009 120.808 81.1431 120.808Z",
    stroke: "#A19FC4",
    strokeOpacity: 0.08,
    strokeWidth: 0.573529
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9038_408)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.1045,
    y: 26.2563,
    width: 32.2184,
    height: 15.1293,
    rx: 1.72059,
    fill: "url(#paint0_linear_9038_408)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.50465,
    filter: "url(#filter1_d_9038_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2949 30.5773C54.2949 30.4189 54.4233 30.2905 54.5817 30.2905H56.0218C56.1802 30.2905 56.3086 30.4189 56.3086 30.5773V37.5684C56.3086 37.7268 56.1802 37.8552 56.0218 37.8552H54.5817C54.4233 37.8552 54.2949 37.7268 54.2949 37.5684V30.5773Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.50465,
    filter: "url(#filter2_d_9038_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2754 32.0905C51.2754 31.9321 51.4038 31.8037 51.5622 31.8037H53.0023C53.1607 31.8037 53.289 31.9321 53.289 32.0905V37.5687C53.289 37.727 53.1607 37.8554 53.0023 37.8554H51.5622C51.4038 37.8554 51.2754 37.727 51.2754 37.5687V32.0905Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.50465,
    filter: "url(#filter3_d_9038_408)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.2549,
    y: 32.8125,
    width: 2.01365,
    height: 5.0431,
    rx: 0.286765,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.50465,
    filter: "url(#filter4_d_9038_408)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.2344,
    y: 34.3257,
    width: 2.01365,
    height: 3.53017,
    rx: 0.286765,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.540713,
    x: 28.1182,
    y: 34.3257,
    width: 13.0887,
    height: 1.26078,
    rx: 0.573529,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1182,
    y: 31.8037,
    width: 6.54436,
    height: 1.22935,
    rx: 0.614677,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_9038_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.465 45.9727C122.183 48.5832 127.412 47.5266 130.145 43.6127C132.878 39.6987 132.08 34.4096 128.362 31.7991C124.644 29.1885 119.414 30.2451 116.681 34.1591C113.948 38.073 114.747 43.3622 118.465 45.9727Z",
    fill: "#A869C1"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.76 45.5027C121.371 48.0386 126.515 46.9216 129.248 43.0076C131.981 39.0937 131.268 33.865 127.657 31.3291C124.045 28.7931 118.902 29.9102 116.169 33.8241C113.436 37.7381 114.148 42.9667 117.76 45.5027Z",
    fill: "url(#paint1_linear_9038_408)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.959 34.4103L125.181 34.8138L127.003 38.6542L126.523 39.3415L120.479 35.0976L120.959 34.4103ZM124.844 38.6261L123.165 41.0318L124.172 41.7391L125.852 39.3334L124.844 38.6261ZM122.793 37.3953L121.113 39.801L122.12 40.5083L123.8 38.1026L122.793 37.3953ZM120.741 36.1651L119.061 38.5708L120.069 39.2781L121.748 36.8724L120.741 36.1651ZM123.654 43.687L117.61 39.4431L118.33 38.4121L124.374 42.656L123.654 43.687Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_9038_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7996 75.4946C16.0053 79.0811 16.7839 84.3732 20.5386 87.3148C24.2932 90.2565 29.6022 89.7338 32.3965 86.1473C35.1908 82.5608 34.4123 77.2686 30.6576 74.327C26.9029 71.3853 21.5939 71.9081 18.7996 75.4946Z",
    fill: "#525ED0"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2704 75.0244C16.6358 78.4059 17.5438 83.5319 21.2984 86.4736C25.0531 89.4152 30.2327 89.0586 32.8673 85.6771C35.5019 82.2955 34.5939 77.1695 30.8392 74.2279C27.0846 71.2862 21.905 71.6428 19.2704 75.0244Z",
    fill: "url(#paint2_linear_9038_408)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4595 84.1223L24.0685 83.277L24.322 83.0055C24.2034 82.9084 24.0919 82.8111 23.9873 82.7137C23.8463 82.5823 23.7205 82.4539 23.61 82.3287L23.1098 82.8647L22.7189 82.0194L23.0957 81.6156C22.2456 80.1199 22.4364 78.7121 23.668 77.3925C24.0726 76.9589 24.5132 76.5989 24.9896 76.3125L25.7848 77.0535C25.2795 77.2685 24.8346 77.5821 24.45 77.9942C23.7119 78.785 23.5984 79.6301 24.1094 80.5294L26.307 78.1747L26.698 79.02L24.5971 81.2711C24.6638 81.3555 24.7628 81.4589 24.8941 81.5813C25.0449 81.7218 25.1843 81.8428 25.3124 81.9443L27.1431 79.9826L27.5374 80.8243L26.0701 82.3965C26.6657 82.6353 27.1626 82.713 27.5608 82.6298C27.959 82.5466 28.3682 82.2799 28.7883 81.8297C29.0885 81.5081 29.3397 81.083 29.542 80.5545L30.2897 81.2513C30.0858 81.7426 29.7493 82.2396 29.2802 82.7422C28.0463 84.0643 26.6362 84.3135 25.0497 83.4899L24.4595 84.1223Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_9038_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.418 112.997C112.29 112.997 116.241 108.933 116.241 103.92C116.241 98.9065 112.29 94.8423 107.418 94.8423C102.545 94.8423 98.5947 98.9065 98.5947 103.92C98.5947 108.933 102.545 112.997 107.418 112.997Z",
    fill: "url(#paint3_linear_9038_408)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.06 101.125C112.23 101.293 112.23 101.566 112.06 101.735C110.936 102.851 107.05 106.712 105.927 107.828C105.845 107.909 105.735 107.954 105.62 107.954C105.505 107.954 105.394 107.909 105.313 107.828C104.62 107.14 102.939 105.47 102.246 104.781C102.077 104.613 102.077 104.34 102.246 104.172C102.434 103.986 102.672 103.749 102.86 103.563C103.029 103.394 103.304 103.394 103.473 103.563C104.131 104.217 105.62 105.695 105.62 105.695C105.62 105.695 109.674 101.668 110.834 100.516C110.915 100.435 111.025 100.39 111.14 100.39C111.255 100.39 111.366 100.435 111.447 100.516L112.06 101.125Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3174 97.3638L55.8015 100.93L52.3174 104.496L48.8332 100.93L52.3174 97.3638Z",
    fill: "url(#paint4_linear_9038_408)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.663 68.6655L143.844 72.9447L139.663 77.224L135.482 72.9447L139.663 68.6655Z",
    fill: "url(#paint5_linear_9038_408)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4697 124.464C42.5623 124.464 44.2587 122.776 44.2587 120.694C44.2587 118.611 42.5623 116.923 40.4697 116.923C38.3771 116.923 36.6807 118.611 36.6807 120.694C36.6807 122.776 38.3771 124.464 40.4697 124.464Z",
    stroke: "url(#paint6_linear_9038_408)",
    strokeWidth: 0.573529
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0556 43.5858C85.3635 43.5858 86.4237 42.5308 86.4237 41.2294C86.4237 39.928 85.3635 38.873 84.0556 38.873C82.7477 38.873 81.6875 39.928 81.6875 41.2294C81.6875 42.5308 82.7477 43.5858 84.0556 43.5858Z",
    stroke: "url(#paint7_linear_9038_408)",
    strokeWidth: 0.573529
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7715 83.8015C69.7715 84.561 70.0732 85.2894 70.6102 85.8264C71.1473 86.3635 71.8757 86.6652 72.6351 86.6652H89.8171C90.5766 86.6652 91.305 86.3635 91.842 85.8264C92.379 85.2894 92.6808 84.561 92.6808 83.8015V75.9265H69.7715V83.8015ZM73.1465 79.9151C73.1465 79.5083 73.3081 79.1181 73.5958 78.8304C73.8835 78.5427 74.2737 78.381 74.6806 78.381H77.1352C77.542 78.381 77.9323 78.5427 78.22 78.8304C78.5077 79.1181 78.6693 79.5083 78.6693 79.9151V80.9379C78.6693 81.3447 78.5077 81.7349 78.22 82.0226C77.9323 82.3103 77.542 82.472 77.1352 82.472H74.6806C74.2737 82.472 73.8835 82.3103 73.5958 82.0226C73.3081 81.7349 73.1465 81.3447 73.1465 80.9379V79.9151ZM89.8171 68.665H72.6351C71.8757 68.665 71.1473 68.9667 70.6102 69.5038C70.0732 70.0408 69.7715 70.7692 69.7715 71.5287V72.8583H92.6808V71.5287C92.6808 70.7692 92.379 70.0408 91.842 69.5038C91.305 68.9667 90.5766 68.665 89.8171 68.665Z",
    fill: "#06C671"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9038_408",
    x: 21.5163,
    y: 26.2563,
    width: 41.3952,
    height: 26.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29412
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.831373 0 0 0 0 0.886275 0 0 0 0.602191 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9038_408",
    x: 46.2655,
    y: 29.1435,
    width: 18.0725,
    height: 23.6233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.01471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.831373 0 0 0 0 0.886275 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9038_408",
    x: 43.246,
    y: 30.6567,
    width: 18.0725,
    height: 22.1106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.01471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.831373 0 0 0 0 0.886275 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9038_408",
    x: 40.2255,
    y: 31.6654,
    width: 18.0725,
    height: 21.1018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.01471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.831373 0 0 0 0 0.886275 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9038_408",
    x: 37.205,
    y: 33.1786,
    width: 18.0725,
    height: 19.5891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.01471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.831373 0 0 0 0 0.886275 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_9038_408",
    x: 115.058,
    y: 30.3662,
    width: 28.7551,
    height: 26.2155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.45588,
    dy: 4.58824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29412
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.623529 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_9038_408",
    x: 17.123,
    y: 68.9807,
    width: 28.4208,
    height: 25.9748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.88235,
    dy: 1.14706
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29412
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.623529 0 0 0 0 0.768627 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_9038_408",
    x: 91.7124,
    y: 87.9599,
    width: 31.4102,
    height: 31.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.44118
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.54902 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9038_408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9038_408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9038_408",
    x1: 43.032,
    y1: 17.9521,
    x2: 32.527,
    y2: 42.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07590"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9038_408",
    x1: 131.873,
    y1: 27.961,
    x2: 112.812,
    y2: 30.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A665D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9038_408",
    x1: 37.9529,
    y1: 90.4447,
    x2: 33.8793,
    y2: 69.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626BE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9038_408",
    x1: 106.88,
    y1: 91.9114,
    x2: 95.9724,
    y2: 104.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC897"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9038_408",
    x1: 52.3174,
    y1: 97.3638,
    x2: 48.7514,
    y2: 100.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC9A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69779"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9038_408",
    x1: 140.036,
    y1: 67.5429,
    x2: 135.009,
    y2: 72.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6ED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAD5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9038_408",
    x1: 40.3957,
    y1: 113.898,
    x2: 34.3513,
    y2: 121.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B362E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9038_408",
    x1: 84.5087,
    y1: 37.4611,
    x2: 80.5898,
    y2: 41.2916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A665D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingCards);
export default __webpack_public_path__ + "static/media/banking_cards.ee02d8752058f3d2c19692ffeadadc43.svg";
export { ForwardRef as ReactComponent };